import {
  Directive,
  DoCheck,
  Output,
  EventEmitter,
  KeyValueDiffers,
  Input
} from "@angular/core";

@Directive({
  selector: "[objectWatcher]"
})
export class ObjectWatcherDirective implements DoCheck {
  private _watchObject: any;
  private _differ: any;
  private _changeCounter = 0;

  @Input("objectWatcher")
  set watchObject(value: any) {
    this._watchObject = value;
    if (!this._differ && value) {
      this._differ = this._differs.find(value).create();
    }
  }
  @Input() checkOnce = true;
  @Input() stopWatching: false;

  @Output() onPropertyChanged = new EventEmitter();

  constructor(private _differs: KeyValueDiffers) { }

  ngDoCheck() {
    if (
      !this._differ ||
      this.stopWatching ||
      (this.checkOnce && this._changeCounter > 0)
    ) {
      return;
    }
    const change = this._differ.diff(this._watchObject);
    if (change) {
      change.forEachChangedItem(item => {
        //
        this._changeCounter++;
        this.onPropertyChanged.emit(item);
      });
    }
  }
}
